import React, { useEffect, useState } from 'react';
import './userManagement.scss';
import { useTranslation } from 'react-i18next';
import {
    Constant,
    CommonService,
    UserManagementService,
    AlignType
} from '../../services/services'
import LoadingContext from './../utils/loadingCompt/loadingContext'
import { Role, User } from '../../models/appModels';
import { StatusCell, EditCommandCell, GetTableConfigs } from './../utils/gridColumn/gridColumn'
import { Table, Empty, Button, Row, Col, List, Card, Spin } from 'antd';
import { PlusOutlined, EditFilled } from '@ant-design/icons'
import AddUpdateUser from './addUpdateUser/addUpdateUser';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroller';

const UserManagement = (props: any) => {
    const { t } = useTranslation();
    const { showLoading, dismissLoading } = React.useContext(LoadingContext)
    const [roleData, setRoleData] = useState<Role[]>([])
    const [userData, setUserData] = useState<User[]>([])
    const [totalItems, setTotalItems] = useState(0)
    const [visibleModal, setVisibleModal] = useState(false);
    const [selectedObject, setSelectedObject] = useState<User | null>();
    const [allowModify, setAllowModify] = useState<boolean>(false)
    const [gridConfigOptions, setGridConfigOptionsValue] = useState<any>({
        pageNumber: 1,
        pageSize: Constant.pageSize,
        sort: "",
        isLoadMore: true,
        showLoading: false
    })


    const statusList = [
        {
            Code: Constant.statusCode.Active,
            Description: t('common.active')
        },
        {
            Code: Constant.statusCode.Inactive,
            Description: t('common.inactive')
        },
        {
            Code: Constant.statusCode.Pending,
            Description: t('common.pending')
        }
    ]

    const editData = (data: any) => {
        let obj = Object.assign({}, data)
        if (obj.TerminationDate) {
            obj.TerminationDate = moment(obj.TerminationDate)
        }
        setSelectedObject(obj)
        setVisibleModal(true)
    }

    const getColumns = () => {
        let columns = [
            {
                title: t('login_page.username'),
                dataIndex: 'UserName',
                key: 'UserName',
                sorter: true,
                ellipsis: true,
                width: 200,
                fixed: true
            },
            {
                title: t('customer_detail.first_name'),
                dataIndex: 'FirstName',
                key: 'FirstName',
                sorter: true,
                ellipsis: true,
                width: 150,
            },
            {
                title: t('customer_detail.last_name'),
                dataIndex: 'Surname',
                key: 'Surname',
                sorter: true,
                ellipsis: true,
                width: 150,
            },
            {
                title: t('customer_detail.email'),
                dataIndex: 'Email',
                key: 'Email',
                sorter: true,
                ellipsis: true,
                width: 200,
            },
            {
                title: t('user_configuration.phone_number'),
                dataIndex: 'PhoneNumber',
                key: 'PhoneNumber',
                sorter: true,
                ellipsis: true,
                width: 150,
            },
            {
                title: t('user_configuration.roles'),
                dataIndex: 'RoleNames',
                key: 'RoleNames',
                ellipsis: true,
                width: 200,
            },
            {
                title: t('common.status'),
                dataIndex: 'StatusCode',
                key: 'StatusCode',
                sorter: true,
                render: (value: any, record: any) => (
                    <StatusCell data={record}
                        activeStatus={t('common.active')}
                        inactiveStatus={t('common.inactive')} 
                        pendingStatus={t('common.pending')}
                        />
                ),
                align: 'center' as AlignType,
                width: 100
            }
        ];
        if (allowModify) {
            columns.push({
                title: t('common.action'),
                dataIndex: 'Id',
                key: 'Id',
                sorter: false,
                render: (value: any, record: any) => (
                    <EditCommandCell data={record} editFunction={editData} />
                ),
                align: 'center' as AlignType,
                width: 80
            })
        }
        return columns
    }

    const getColumnsJPN = () => {
        let columns = [
            {
                title: t('login_page.username'),
                dataIndex: 'UserName',
                key: 'UserName',
                sorter: true,
                ellipsis: true,
                width: 200,
                fixed: true
            },           
            {
                title: t('customer_detail.last_name'),
                dataIndex: 'Surname',
                key: 'Surname',
                sorter: true,
                ellipsis: true,
                width: 150,
            },
            {
                title: t('customer_detail.first_name'),
                dataIndex: 'FirstName',
                key: 'FirstName',
                sorter: true,
                ellipsis: true,
                width: 150,
            },
            {
                title: t('customer_detail.email'),
                dataIndex: 'Email',
                key: 'Email',
                sorter: true,
                ellipsis: true,
                width: 200,
            },
            {
                title: t('user_configuration.phone_number'),
                dataIndex: 'PhoneNumber',
                key: 'PhoneNumber',
                sorter: true,
                ellipsis: true,
                width: 150,
            },
            {
                title: t('user_configuration.roles'),
                dataIndex: 'RoleNames',
                key: 'RoleNames',
                ellipsis: true,
                width: 200,
            },
            {
                title: t('common.status'),
                dataIndex: 'StatusCode',
                key: 'StatusCode',
                sorter: true,
                render: (value: any, record: any) => (
                    <StatusCell data={record}
                        activeStatus={t('common.active')}
                        inactiveStatus={t('common.inactive')}
                        pendingStatus={t('common.pending')} />
                ),
                align: 'center' as AlignType,
                width: 100
            }
        ];
        if (allowModify) {
            columns.push({
                title: t('common.action'),
                dataIndex: 'Id',
                key: 'Id',
                sorter: false,
                render: (value: any, record: any) => (
                    <EditCommandCell data={record} editFunction={editData} />
                ),
                align: 'center' as AlignType,
                width: 80
            })
        }
        return columns
    }
    const getUsers = (pageNumber: number, pageSize: number, sort: string, isShowLoading: boolean = false, isScroll: boolean = false) => {
        if (isShowLoading)
            showLoading()
        UserManagementService.getUsers(pageNumber, pageSize, sort)
            .finally(() => {
                if (isShowLoading)
                    dismissLoading()
            })
            .then(result => {
                if (result.data) {
                    if (isScroll) {
                        let list = userData.map(x => Object.assign({}, x))
                        list = list.concat(result.data.ObjectList)
                        setUserData(list)
                        setGridConfigOptionsValue({
                            ...gridConfigOptions,
                            pageNumber: pageNumber,
                            showLoading: false
                        })
                    }
                    else {
                        setUserData(result.data.ObjectList)
                    }
                    setTotalItems(result.data.TotalItems)
                }

            })
            .catch(error => CommonService.handleErrorResponse(error))
    }

    const getRoles = () => {
        showLoading()
        UserManagementService.getAllRoles()
            .finally(() => dismissLoading())
            .then(result => {
                if (result.data) {
                    setRoleData(result.data)
                }
            })
            .catch(error => CommonService.handleErrorResponse(error))
    }

    const onTableChange = (pagination: any, filters: any, sorter: any, extra: any) => {
        getUsers(pagination.current, pagination.pageSize, CommonService.getSortString(sorter))
        setGridConfigOptionsValue({
            pageNumber: pagination.current,
            pageSize: pagination.pageSize,
            sort: CommonService.getSortString(sorter)
        })
    }

    const handleCancel = (objectData?: User) => {
        setVisibleModal(false)
        if (objectData)
            getUsers(gridConfigOptions.pageNumber, gridConfigOptions.pageSize, gridConfigOptions.sort, true)
    };

    const addUser = () => {
        setVisibleModal(true)
        setSelectedObject(null)
    }

    const handleInfiniteOnLoad = (pageNumber: any) => {
        setGridConfigOptionsValue({
            ...gridConfigOptions,
            showLoading: true
        })
        if (userData.length >= totalItems) {
            setGridConfigOptionsValue({
                ...gridConfigOptions,
                isLoadMore: false,
                showLoading: false
            });
            return;
        }
        getUsers(pageNumber, gridConfigOptions.pageSize, gridConfigOptions.sort, false, true)
    }

    useEffect(() => {
        setAllowModify(CommonService.allowModyfyAndAccessPage(Constant.appPageIds.UserManagement))
        getUsers(gridConfigOptions.pageNumber, gridConfigOptions.pageSize, gridConfigOptions.sort, true)
        getRoles()
        return () => {
            UserManagementService.cancelRequest()
        }
    }, [])


    return (
        <div className="user-management">
            {
                allowModify &&
                <div className="action-btn-group">
                    <Button className="primary-btn" icon={<PlusOutlined />} onClick={addUser}>
                        {t("common.add")}
                    </Button>
                </div>
            }

            <Row>
            {process.env.REACT_APP_COUNTRY_CODE !== Constant.countryCodes.JP && (
                <>
                <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 24 }}>
                    <Table
                        {...GetTableConfigs(getColumns(), userData, totalItems, "Id", onTableChange)}
                    />
                </Col>
                </>
                )
            }  
              {process.env.REACT_APP_COUNTRY_CODE === Constant.countryCodes.JP && (
                <>
                <Col xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 24 }}>
                    <Table
                        {...GetTableConfigs(getColumnsJPN(), userData, totalItems, "Id", onTableChange)}
                    />
                </Col>
                </>
                )
            }  
                <Col xs={{ span: 24 }} md={{ span: 0 }}>
                    <div className="infinite-scroll-container">
                        <InfiniteScroll
                            pageStart={1}
                            initialLoad={false}
                            loadMore={handleInfiniteOnLoad}
                            hasMore={!gridConfigOptions.showLoading && gridConfigOptions.isLoadMore}
                            useWindow={false}
                        >
                            <List
                                className="card-list"
                                dataSource={userData}
                                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("common.no_data")} /> }}
                                renderItem={(item: User, i: any) => (
                                    <List.Item>
                                        <Card className="card-selection card-details" key={i}>
                                            <Row className="flex-center">
                                                <Col xs={{ span: 6 }}>
                                                    <label className="title-field truncate">{t("login_page.username")}</label>
                                                </Col>
                                                <Col xs={{ span: 16 }}>
                                                    <label className="text-field truncate semi-bold-text">{item.UserName}</label>
                                                </Col>
                                                {
                                                    allowModify &&
                                                    <Col xs={{ span: 2 }} className="actions text-right">
                                                        <EditFilled className="action-icon" onClick={() => editData(item)} />
                                                    </Col>
                                                }

                                                <Col xs={{ span: 6 }}>
                                                    <label className="title-field truncate">{t("customer_detail.email")}</label>
                                                </Col>
                                                <Col xs={{ span: 18 }}>
                                                    <label className="text-field truncate semi-bold-text">{item.Email}</label>
                                                </Col>
                                                <Col xs={{ span: 6 }}>
                                                    <label className="title-field truncate">{t("user_configuration.roles")}</label>
                                                </Col>
                                                <Col xs={{ span: 18 }}>
                                                    <label className="text-field truncate semi-bold-text">{item.RoleNames}</label>
                                                </Col>
                                                {process.env.REACT_APP_COUNTRY_CODE !== Constant.countryCodes.JP && (
                                                    <>
                                                <Col xs={{ span: 12 }}>
                                                    <label className="title-field truncate">{t("customer_detail.last_name")}</label>
                                                    <label className="text-field truncate semi-bold-text">{item.Surname}</label>
                                                </Col>                                                
                                                <Col xs={{ span: 12 }}>
                                                    <label className="title-field truncate">{t("customer_detail.first_name")}</label>
                                                    <label className="text-field truncate semi-bold-text">{item.FirstName}</label>
                                                </Col>
                                                    </>
                                                    )
                                                }
                                                {process.env.REACT_APP_COUNTRY_CODE === Constant.countryCodes.JP && (
                                                    <>
                                                <Col xs={{ span: 12 }}>
                                                    <label className="title-field truncate">{t("customer_detail.last_name")}</label>
                                                    <label className="text-field truncate semi-bold-text">{item.Surname}</label>
                                                </Col>
                                                <Col xs={{ span: 12 }}>
                                                    <label className="title-field truncate">{t("customer_detail.first_name")}</label>
                                                    <label className="text-field truncate semi-bold-text">{item.FirstName}</label>
                                                </Col>
                                                    </>
                                                    )
                                                }       
                                                <Col xs={{ span: 19 }}>
                                                    <label className="title-field truncate">{t("user_configuration.phone_number")}</label>
                                                    <label className="text-field truncate semi-bold-text">{item.PhoneNumber}</label>
                                                </Col>
                                                <Col xs={{ span: 5 }}>
                                                    <StatusCell data={item}
                                                        activeStatus={t('role_management.current')}
                                                        inactiveStatus={t('role_management.closed')}
                                                        pendingStatus={t('role_management.pending')} />
                                                </Col>

                                            </Row>
                                        </Card>
                                    </List.Item>
                                )}
                            />
                            {gridConfigOptions.showLoading && gridConfigOptions.isLoadMore &&
                                <div className="infinite-scroll-loading-container">
                                    <Spin />
                                </div>
                            }
                        </InfiniteScroll>
                    </div>
                </Col>
            </Row>
            {
                visibleModal &&
                <AddUpdateUser handleCancel={handleCancel} objectData={selectedObject} statusList={statusList} roleList={roleData}></AddUpdateUser>
            }
        </div>
    )
}

export default UserManagement